export const minutesDecimalFormatter = (
  duration: string | undefined
): string | undefined => {
  if (!duration || !Number.parseFloat(duration)) {
    return '0:00';
  }
  const durationMinutes = Number.parseFloat(duration);
  return `${Math.trunc(
    Number.parseFloat(durationMinutes?.toString() || '0')
  )}:${
    Math.round(
      (Number.parseFloat(durationMinutes?.toString() || '0') % 1) * 60
    ) < 10
      ? '0' +
        Math.round(
          (Number.parseFloat(durationMinutes?.toString() || '0') % 1) * 60
        )
      : Math.round(
          (Number.parseFloat(durationMinutes?.toString() || '0') % 1) * 60
        )
  }`;
};

export const secondsDecimalFormatter = (
  duration: string | undefined
): string | undefined => {
  if (!duration || !Number.parseFloat(duration)) {
    return '0:00';
  }
  const durationSeconds = Number.parseFloat(duration);
  const durationMinutes = durationSeconds / 60;
  return minutesDecimalFormatter(durationMinutes.toString());
};
